import React from 'react'
import { useState,useEffect } from 'react';
import GreenButton from '../../../../components/forms/greenButton';
import FormInput from '../../../../components/forms/formInput';
import FormTextarea from '../../../../components/forms/formTextarea';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ApiUrl from '../../../../configTools/apiUrl'

const Itdarea = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [fysImage, setFysImage] = useState('');
    const [fysIdImage, setFysIdImage] = useState(0);
    const [fysTitle, setFysTitle] = useState('');
    const [fysIdTitle, setFysIdTitle] = useState(0);
    const [fysDetails, setfysDetails] = useState('');
    const [fysIdDetails, setfysIdDetails] = useState(0);
    const showPreviewfys = (e) =>{
        if(e.target.files && e.target.files[0]){
            let imageFile = e.target.files[0];
            const formData = new FormData();
            formData.append("file",imageFile);
            fetch(ApiUrl.API_URL_File, {
                method: 'POST',
                body: formData
            })
            .then(res=>res.json())
            .then(data =>{
                if(data.success){
                    let Body;
                    if(fysIdImage === 0){
                        Body = {
                            value: data.url,
                            pageid: 1,
                            componentid: 2
                        }
                    }
                    else{
                        Body = {
                            id: fysIdImage,
                            value: data.url,
                            pageid: 1,
                            componentid: 2
                        }
                    }
                    fetch(ApiUrl.API_URL_Page, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer '+User.token
                        },
                        body: JSON.stringify(Body)
                    })
                    .then(res=>res.json())
                    .then(data =>{
                        if(data.success){
                            get_admin_list();
                        }
                        else{
                            console.log(data.responce);
                        }
                    });
                }
                else{
                    console.log(data.responce);
                }
            });
        }
    }
    const post_title = () =>{
        const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
        let Body;
        if(fysIdTitle === 0){
            Body = {
                value: fysTitle,
                pageid: 1,
                componentid: 3
            }
        }
        else{
            Body = {
                id: fysIdTitle,
                value: fysTitle,
                pageid: 1,
                componentid: 3
            }
        }
        fetch(ApiUrl.API_URL_Page, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            },
            body: JSON.stringify(Body)
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.success){
                get_admin_list();
                setTimeout(() => {
                  toast.update(toastid, { render: "Added", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
                }, 500);
            }
            else{
                setTimeout(() => {
                  toast.update(toastid, { render: data.responce, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
                }, 500);
            }
        });
    }
    const post_details = () =>{
        const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
        let Body;
        if(fysIdDetails === 0){
            Body = {
                value: fysDetails,
                pageid: 1,
                componentid: 4
            }
        }
        else{
            Body = {
                id: fysIdDetails,
                value: fysDetails,
                pageid: 1,
                componentid: 4
            }
        }
        fetch(ApiUrl.API_URL_Page, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            },
            body: JSON.stringify(Body)
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.success){
                get_admin_list();
                setTimeout(() => {
                  toast.update(toastid, { render: "Added", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
                }, 500);
            }
            else{
                setTimeout(() => {
                  toast.update(toastid, { render: data.responce, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
                }, 500);
            }
        });
    }
    const delete_admin = (id) =>{
        fetch(ApiUrl.API_URL_PageDelete+"/"+id,{
          method: 'GET',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+User.token
          }
        })
        .then(res=>res.json())
        .then(data =>{
          if(data.success){
            get_admin_list();
          }
          else{
            console.log(data.responce);
          }
        });
    }
    const get_admin_list = () =>{
        fetch(ApiUrl.API_URL_Page+"/1/2",{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.length !== 0){
                setFysIdImage(data[0].id);
                setFysImage(data[0].value);
            }
            else{
                setFysIdImage(0);
                setFysImage('');
            }
        });
        fetch(ApiUrl.API_URL_Page+"/1/3",{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.length !== 0){
                setFysIdTitle(data[0].id);
                setFysTitle(data[0].value);
            }
            else{
                setFysIdTitle(0);
                setFysTitle('');
            }
        });
        fetch(ApiUrl.API_URL_Page+"/1/4",{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.length !== 0){
                setfysIdDetails(data[0].id);
                setfysDetails(data[0].value);
            }
            else{
                setfysIdDetails(0);
                setfysDetails('');
            }
        });
    }
    useEffect(() => {
        fetch(ApiUrl.API_URL_Page+"/1/2",{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.length !== 0){
                setFysIdImage(data[0].id);
                setFysImage(data[0].value);
            }
        });
        fetch(ApiUrl.API_URL_Page+"/1/3",{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.length !== 0){
                setFysIdTitle(data[0].id);
                setFysTitle(data[0].value);
            }
        });
        fetch(ApiUrl.API_URL_Page+"/1/4",{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            }
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.length !== 0){
                setfysIdDetails(data[0].id);
                setfysDetails(data[0].value);
            }
        });
    },[])
  return (
    <div className='admin_forms_container'>
        <h3 style={{padding:"10px 0px", fontWeight:"500", fontSize:"20px"}}>Image with text area</h3>
        <div className='admin_forms_multirow'>
            <div className='admin_col_25'>
                {fysIdImage === 0 &&
                    <div className='admin_forms_container'>
                        <label style={{cursor:"pointer"}}>
                            <div style={{
                                width: "100%",
                                paddingTop: "80%",
                                borderRadius: "3px",
                                border: "2px dashed black",
                                position: "relative"
                            }}>
                                <div style={{display:"flex", position:"absolute", top:"0", left:"0", bottom:"0", width:"100%", justifyContent:"center",alignItems:"center"}}>
                                    <p>Upload File</p>
                                </div>
                            </div>
                            <input type="file" style={{display:"none"}} onChange={showPreviewfys}/>
                        </label>
                    </div>
                }
                {fysIdImage !== 0 &&
                    <div className='admin_forms_container'>
                        <div style={{cursor:"pointer"}}>
                            <div style={{
                                backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+fysImage})`,
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                width: "100%",
                                paddingTop: "80%",
                                borderRadius: "3px",
                                border: "2px solid black",
                                position:"relative"
                            }}>
                                <div style={{
                                    position:"absolute",
                                    width:"20%",
                                    top:"0",
                                    right:"0"
                                }}>
                                    <GreenButton Value='X' Action={()=>{
                                    delete_admin(fysIdImage)
                                }}/>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div className='admin_col_25'>
                <div className='admin_forms_container'>
                    <FormInput Lable='Title' Type='text' Placeholder='Enter Title' Value={fysTitle} setValue={setFysTitle}/>
                    <GreenButton Value={'Add'} Action={()=>{post_title()}}/>
                </div>
            </div>
            <div className='admin_col_25'>
                <div className='admin_forms_container'>
                    <FormTextarea Lable='Title' Placeholder='Enter Title' Value={fysDetails} setValue={setfysDetails}/>
                    <GreenButton Value={'Add'} Action={()=>{post_details()}}/>
                </div>
            </div>
        </div>
      <ToastContainer />
    </div>
  )
}

export default Itdarea
